<template>
  <div>
    <Head />

    <div class="wrap" :class="{miniWrap: platform}">
      <div class="banner">
        <!-- <Carousel autoplay v-model="init" loop arrow='never' class="banner_swipe" :height="360">
          <CarouselItem v-for="(item, index) in bgArr" :key="index">
            <div class="demo-carousel" @click="watchFun">
              <img :src="item" alt="">
              <div class="qrCode"></div>
              <p class="textQr" :class="`textQr${index}`">扫码开启你的饷店</p>
            </div>
          </CarouselItem>
        </Carousel> -->
        <el-carousel :initial-index="init" arrow='never' class="banner_swipe" height="360px">
          <el-carousel-item v-for="(item, index) in bgArr" :key="index">
            <div class="demo-carousel" @click="watchFun">
              <img class="item" :src="item" alt="">
              <!-- <img :src="qrImgUrl" class="qrCode" v-if="qrImgUrl">
              <p class="textQr" :class="`textQr${index}`" v-if="qrImgUrl">扫码开启你的饷店</p> -->
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="introduce">
        <h3>什么是饷店</h3>
        <p class="mt">饷店是去中心化的品牌特卖平台，用户在微信中搜索“饷店”小程序，购买高性</p>
        <p>价比的商品、享受店主提供的包括选品、推荐、售后在内的管家式购物服务。目前</p>
        <p>饷店已连接超万家品牌，并聚集200+万家数字化小店</p>
      </div>
      <div class="friends">
        <div class="headBar">用饷店创业的店主们</div>
        <ul class="friend-items">
          <li>
            <div class="img"></div>
            <div class="msg">
              <p class="name">青青</p>
              <p class="age">主持人</p>
              <p class="tip tip1">事业的丰收让家庭格外和睦， 家庭的和睦也让自己更有自 信坚定自己的事业，这一个 良性循环</p>
            </div>
          </li>
          <li>
            <div class="img"></div>
            <div class="msg">
              <p class="name">徐悦佳</p>
              <p class="age">精锐咨询CEO</p>
              <p class="tip tip1">再小的个体，也有自己的个人品牌，这个品牌是由个人信誉、个人价值观做背书的</p>
            </div>
          </li>
          <li>
            <div class="img"></div>
            <div class="msg">
              <p class="name">七七</p>
              <p class="age">宝妈</p>
              <p class="tip tip1">女人，一定要有独立的经济能力，体现自己的社会价值，才会得到更多的爱与尊重</p>
            </div>
          </li>
          <li>
            <div class="img"></div>
            <div class="msg">
              <p class="name">香槟妈妈</p>
              <p class="age">宝妈</p>
              <p class="tip tip1">怕拒绝是自己遇到的最大的障碍。但既然开了店，就会坚持做下去。我想活成自己想要的样子</p>
            </div>
          </li>
        </ul>
        <div class="watch-btn" @click="watchFun">查看饷店功能与服务</div>
      </div>
      <!-- <img class="service-entrance"
         src="../common/img/service-entrance.png"
         @click="onService" />
      <Service ref="service" /> -->
      <div class="parters">
        <div class="headBar">品牌商品入驻</div>
        <div class="parters-items"></div>
      </div>
    </div>

    <Foot />
    <Login v-show="showLogin" />
    <LoginOut v-show="showLoginOut" />
  </div>
</template>

<script>
import Head from 'components/header'
import Foot from 'components/footer'
import Login from 'components/login'
import LoginOut from 'components/loginout'
// import Service from 'components/service'
import { mapState, mapMutations } from 'vuex'
import b1 from '../common/img/new/index-banner1.jpg'
import b2 from '../common/img/new/index-banner2.jpg'
import { getBarCode } from 'api/http'
export default {
  data() {
    return {
      init: 0,
      bgArr: [b1, b2]
    }
  },
  created() {
    this.$track.sendLog('pageview', {
      spm: '3.1600'
    })
    this.setName(1)
    this.setPlatform()
    this.getCode()
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    Head,
    Foot,
    Login,
    LoginOut
  },
  computed: {
    ...mapState([
      'platform',
      'userInfo',
      'showLogin',
      'showLoginOut',
      'qrImgUrl'
    ])
  },
  methods: {
    ...mapMutations(['setName', 'setPlatform','setLoginWrap','setQrImg']),
    async getCode() {
      let that = this
      let defaultQr = 'https://pic.aikucun.com/qrcode.jpg'

      let query = that.$route.query
      query = Object.keys(query).length ? query : JSON.parse(localStorage.getItem('queryQrParams') || '{}')
      console.log('query', query)
      if(Object.keys(query).length) {
        localStorage.setItem('queryQrParams', JSON.stringify(query))
        if(that.qrImgUrl) {
          console.log('已有二维码', that.qrImgUrl)
          return
        }

        const { campaign_id, utm_campaign, utm_medium, utm_source, utm_content, utm_term } = query
        let queryParams = {
          campaignId: campaign_id,
          utmCampaign: utm_campaign,
          utmMedium: utm_medium,
          utmSource: utm_source,
          utmContent: utm_content,
          utmTerm: utm_term
        }
        let qrData = await getBarCode(queryParams).catch(er=> {
          console.log('获取二维码信息Error', er)
          that.setQrImg(defaultQr)
        })
        if(qrData && qrData.success) {
          console.log('获取到接口数据：', qrData)
          that.setQrImg(qrData.data)
        } else {
          console.log('获取二维码信息失败', qrData)
          that.setQrImg(defaultQr)
        }
      } else {
        console.log('没有参数默认二维码展示中...')
        that.setQrImg(defaultQr)
      }
    },
    watchFun() {
      this.$track.sendLog('click', {
        spm: '3.1600.1799'
      })
      this.$router.push('/shop')
    },
    onService() {
     let token = localStorage.getItem('akc_token')
      let akid = localStorage.getItem('akc_akid')
      let vipLevel = localStorage.getItem('akc_vip_level')
      if (!token || !akid || !vipLevel) {
        this.setLoginWrap(true)
        return
      }
      this.$refs.service.show(token, akid, vipLevel)
    },
  }
}
</script>

<style scoped lang="less">
  .wrap {
    width: 100%;
    background: #fff;
    .banner {
      width: 100%;
      .banner_swipe {
        height: 100%;
        width: 100%;
        .demo-carousel {
          position: relative;
        }
        img.item {
          height: 100%;
          width: 100%;
        }
        .qrCode {
          position: absolute;
          top: 204px;
          left: 142px;
          width: 107px;
          height: 107px;
          background: red;
          border-radius: 5px;
        }
        .textQr {
          position: absolute;
          top: 318px;
          left: 136px;
          font-size: 12px;
          font-family:PingFangSC-Regular,PingFang SC,Arial, Helvetica, sans-serif;
          font-weight:400;
          line-height:16px;
          letter-spacing:4px;
          &.textQr0 {
            color:rgba(255,255,255,1);
          }
          &.textQr1 {
            color: #666;
          }
        }
      }
    }
    .service-entrance {
      width: 90px;
      height: 100px;
      position: fixed;
      bottom: 60px;
      right: 0;
      z-index: 100;
    }   
    .introduce {
      text-align: center;
      h3 {
        font-size:36px;
        font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
        font-weight:800;
        color:#333;
        line-height:50px;
        margin-top: 69px;
      }
      p {
        font-size:16px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:#666;
        line-height:28px;
        &.mt {
          margin-top: 16px;
        }
      }
    }
    .headBar {
      font-size:36px;
      font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
      font-weight:800;
      color:#333;
      line-height:50px;
      margin-top: 69px;
    }
    .friends {
      .friend-items {
        height: 320px;
        margin-top: 47px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        li {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          width: 220px;
          height: 100%;
          text-align: left;
          background: #F5F5F5;
          .img {
            width: 100%;
            height: 152px;
            background-size: cover;
            background-repeat: no-repeat;
          }
          .msg {
            padding: 10px 22px 12px 16px;
            p.name {
              font-size:18px;
              font-family:PingFang-SC-Heavy,microsoft yahei,arial,hiragino sans gb;
              font-weight:800;
              color:#333;
              line-height:25px;
            }
            p.age {
              font-size:14px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:#666;
              line-height:22px;
            }
            p.tip1 {
              margin-top: 7px;
            }
            p.tip {
              line-height: 22px;
              font-size: 14px;
            }
          }
          &:first-child .img {
            background-image: url('../common/img/new/beaty1.png');
            background-position: center 25%;
          }
          &:nth-child(2) .img {
            background-image: url('../common/img/new/beaty2.png');
            background-position: center 102%;
          }
          &:nth-child(3) .img {
            background-image: url('../common/img/new/beaty3.png');
          }
          &:last-child .img{
            background-image: url('../common/img/new/beaty4.png');
          }
        }
      }
      .watch-btn {
        margin: 20px auto 0;
        width:180px;
        height:44px;
        background:#EC2232;
        border-radius:2px;
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:#fff;
        line-height:44px;
        cursor: pointer;
        &:hover {
          background:#FC3142;
        }
      }
    }
    .parters {
      padding: 12px 0 45px 0;
      .parters-items {
        height: 270px;
        width: 100%;
        background: url('../common/img/new/logos.png');
        background-size: 100% 100%;
        overflow: hidden;
      }
    }
  }
</style>
